<template>
  <div class="image-preview">
    <div ref="images" class="preview-list" v-viewer='{rotatable: false,scalable: false}'>
      <div style="position: relative;float: left;" v-if="images.length" v-for="(src,k) in images" :key="src.id">
        <div class="removeBtn"
             title="删除该图片"
             @click="removes(src.id,k)"><i class="el-icon-delete" style="font-size: 16px;color: #fff"></i></div>
        <div>
          <img class="item-inline item_image" :class="'item_image'+k" v-lazy="src.ossUrl" >
          <!--<div v-if="textAreas">-->
            <!--<textarea class="areainput" v-model="textAreas[k]"></textarea>-->
          <!--</div>-->

        </div>
      </div>
    </div>
    <ul class="ul-topline">
      <li class="item-inline" v-for="src in words" :key="src.id">
        <div class="removeBtn"
             title="删除该文档"
             @click="removes(src.id)"><i class="el-icon-delete" style="font-size: 16px;color: #fff"></i></div>
        <a :href="src.ossUrl| ossUrlFilter()" :download="src.name">
          <img class="icon-img" src="https://clourd-static.oss-cn-hangzhou.aliyuncs.com/wap%2Fimgs%2Fword-iocn.svg">
          <span class="item-size">
         {{renderSize(src.size)}}
    </span>
          <div class="ell">
            {{src.name}}
          </div>
        </a>
      </li>
    </ul>
    <ul class="ul-topline">
      <li class="item-inline" v-for="src in excels" :key="src.id">
        <div class="removeBtn"
             title="删除该文档"
             @click="removes(src.id)"><i class="el-icon-delete" style="font-size: 16px;color: #fff"></i></div>
        <a :href="src.ossUrl| ossUrlFilter()" :download="src.name">
          <img class="icon-img" src="https://clourd-static.oss-cn-hangzhou.aliyuncs.com/wap%2Fimgs%2Fexcel.svg">
          <span class="item-size">
    {{renderSize(src.size)}}
    </span>
          <div class="ell">
     {{src.name}}
          </div>
        </a>
      </li>
    </ul>
    <ul class="ul-topline">
      <li class="item-inline" v-for="src in others" :key="src.id">
        <div class="removeBtn"
             title="删除该文档"
             @click="removes(src.id)"><i class="el-icon-delete" style="font-size: 16px;color: #fff"></i></div>
        <a :href="src.ossUrl| ossUrlFilter()" :download="src.name">
          <img class="icon-img" style="width: 33px"
               src="https://clourd-static.oss-cn-hangzhou.aliyuncs.com/wap%2Fimgs%2Ficon_other.svg">
          <span class="item-size">
    {{renderSize(src.size)}}
    </span>
          <div class="ell">
         {{src.name}}
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  // import {isImage, isArray} from '@/utils/index'

  Vue.use(Viewer)

  function isImage(ossUrl) {
    return (ossUrl && /.(jpeg|gif|jpg|png)$/.test(ossUrl.toLowerCase()))
  }

  export default {
    name: 'ImagePreview',
    props: {
      textAreas:{

      },
      businessId: {},
      styleName: {
        default: 'Q99'
      },
      viewLists: {}
    },
    data() {
      return {
        selfTextAreas: [],
      }
    },
    // watch:{
    //   images(n){
    //     this.textAreas.length=n.length
    //   }
    // },
    computed: {

      fileList() {
        return this.viewLists
      },

      // 分离出图片组
      images: function () {
        const {fileList} = this
        if (Array.isArray(fileList)) {
       let arr= fileList.filter(f => {
            return isImage(f.ossUrl || '')
          })
          // arr.forEach(v=>{
          //   let img = new Image();
          //
          //   setTimeout(()=>{
          //     img.src=v.ossUrl;
          //   },1000)
          //
          //
          //   document.getElementById('cons').appendChild(img)
          //
          // })

           return arr

        }
        return [];
      },
      words() {
        return this.fileList.filter(v => {
          return (v.ossUrl && /.(doc|docx)$/.test(v.ossUrl.toLowerCase()))
        })
      },
      excels() {
        return this.fileList.filter(v => {
          return (v.ossUrl && /.(xls|xlsx)$/.test(v.ossUrl.toLowerCase()))
        })
      },
      others() {
        return this.fileList.filter(v => {
          return !(/.(xls|xlsx|doc|docx)$/.test(v.ossUrl.toLowerCase())) && !isImage(v.ossUrl)
        })
      }
    },
    methods: {
      // getTextAreas(v){
      //   return this.textAreas
      // },
      renderSize(value) {
        if (value === null || value === '') {
          return '0 Bytes'
        }
        const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        let index = 0
        let srcsize = parseFloat(value)
        index = Math.floor(Math.log(srcsize) / Math.log(1024))
        let size = srcsize / Math.pow(1024, index)
        //  保留的小数位数
        size = size.toFixed(2)
        return size + unitArr[index]
      },
      removes(uid,k) {

        // this.textAreas.splice(k,1)
        //删除图片

        this.$fetchData(this.$api.imageFile.remove + "/" + uid, [], "POST").then(
          res => {
            //因为只能单独删除。所以成功了，直接更新数组即可
            let fileList = this.fileList.filter(v => {
              return v.id !== uid
            })
            this.$emit('removesList', fileList,k)

          }
        );
      }

    }

  }
</script>

<style scoped lang="scss">
  .removeBtn {
    position: absolute;
    z-index: 1;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    width: 26px;
    height: 26px;
    line-height: 26px;
    border-radius: 26px;
    border: 1px solid #ddd;
    text-align: center;
  }
  .areainput{
    margin-left: 2px;
    padding: 3px;
    width: 150px;
    height: 50px;
    border-color: #dddddd;
    &:focus{
      border-color: #999999;
    }
  }

  .image-preview {
    min-height: auto;
    margin-top: 10px;
    margin-bottom: 10px;

    .icon-img {
      width: 36px;
    }

    .item-inline {
      width: 150px;
      display: inline-block;
      margin: 2px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:hover {
        border-color: #409EFF;
      }
    }

    .item_image {
      height: 150px;
      background: url("https://gtms02.alicdn.com/tfs/TB1y4QbSXXXXXbgapXXXXXXXXXX-50-50.gif") no-repeat center;
    }

    .ell {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 12px;
      text-indent: 6px;
    }

    .item-size {
      color: #409EFF;
      font-size: 12px;
      vertical-align: 6px;
    }

    .preview-list {
      overflow: hidden;
      /*.item-inline {*/
      /*.item_image {*/
      /*width: 150px;*/
      /*height: 150px;*/
      /*padding: 2px;*/

      /*&:hover, &:focus {*/
      /*border-color: #409EFF;*/
      /*}*/
      /*}*/

      /*.item_actions {*/
      /*position: absolute;*/
      /*width: 100%;*/
      /*height: 100%;*/
      /*left: 0;*/
      /*top: 0;*/
      /*cursor: default;*/
      /*text-align: center;*/
      /*color: #ffffff;*/
      /*background-color: rgba(0, 0, 0, 0.5);*/
      /*transition: opacity .3s;*/
      /*opacity: 0;*/
      /*font-size: 20px;*/

      /*span {*/
      /*cursor: pointer;*/
      /*}*/

      /*&:hover {*/
      /*opacity: 1;*/
      /*}*/

      /*&:after {*/
      /*content: '';*/
      /*width: 0;*/
      /*height: 100%;*/
      /*vertical-align: middle;*/
      /*display: inline-block;*/
      /*}*/
      /*}*/
      /*}*/

      /*.item {*/
      /*font-size: 13px;*/
      /*padding: 4px;*/

      /*.item_name {*/
      /*color: #606266;*/
      /*margin-right: 40px;*/
      /*overflow: hidden;*/
      /*padding-left: 4px;*/
      /*text-overflow: ellipsis;*/
      /*transition: color .3s;*/
      /*white-space: nowrap;*/
      /*}*/

      /*.item-size {*/
      /*color: #409EFF;*/
      /*}*/
      /*}*/
    }
  }
</style>
